import { supabase } from "../../supabase/supabase";

const DEFAULT_PUBLISH_API_URL = "https://api.hirevox.ai";
const DEFAULT_PUBLISH_TOKEN = "a9f3c2e47b8d5f0196c4a2e8b7d3f5c1";

const normalizeBaseUrl = (url: string) => url.replace(/\/+$/, "");

export type AgentPublishSource = "voxi" | "supabase";
export type AgentPublishType = "voice" | "video";
export type AgentPublishFeatureType = "job" | "campaign";
export type AgentPublishVersion = 1 | 2;

export interface PublishAgentRequest {
  name: string;
  sourceId: string;
  source?: AgentPublishSource;
  type?: AgentPublishType;
  featureType?: AgentPublishFeatureType;
  version?: AgentPublishVersion;
}

export async function publishAgent({
  name,
  sourceId,
  source = "supabase",
  type = "voice",
  featureType = "job",
  version = 1,
}: PublishAgentRequest) {
  const baseUrl = normalizeBaseUrl(
    import.meta.env.VITE_AGENT_PUBLISH_API_URL ||
      import.meta.env.API_URL ||
      DEFAULT_PUBLISH_API_URL
  );
  const configuredToken =
    import.meta.env.VITE_AGENT_PUBLISH_TOKEN || DEFAULT_PUBLISH_TOKEN;
  const {
    data: { session },
  } = await supabase.auth.getSession();
  const token = configuredToken || session?.access_token;

  if (!token) {
    throw new Error("No auth token available for publishing");
  }

  const response = await fetch(`${baseUrl}/voice-agents`, {
    method: "POST",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json",
      Authorization: `${token}`,
    },
    body: JSON.stringify({
      name,
      source,
      source_id: sourceId,
      type,
      feature_type: featureType,
      version,
    }),
  });

  const result = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(
      result?.detail ||
        result?.error ||
        result?.message ||
        "Failed to publish assistant"
    );
  }

  return result;
}
